import { render, staticRenderFns } from "./CenterPanel.vue?vue&type=template&id=358e54c8&scoped=true&"
import script from "./CenterPanel.vue?vue&type=script&lang=js&"
export * from "./CenterPanel.vue?vue&type=script&lang=js&"
import style0 from "./CenterPanel.vue?vue&type=style&index=0&id=358e54c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "358e54c8",
  null
  
)

export default component.exports